<div class="component-card">
  <div class="w-100 d-flex justify-content-between align-items-center">
    <h1 class="component-title mb-0">{{'BUSINESS.MEMBERSHIP_PLANS'|translate}}</h1>
    <div class="w-50 d-flex justify-content-end align-items-center">
      <button class="btn_without_color btn_border_color me-2 lh-12px" (click)="addOrUpdateSpecialOffer()" *ngIf="specialOfferPresent">
        {{'BUSINESS.UPDATE_SPECIAL_OFFER' | translate}}</button>
      <button class="btn_without_color btn_border_color me-2 lh-12px" (click)="addOrUpdateSpecialOffer()" *ngIf="!specialOfferPresent">
        {{'BUSINESS.CREATE_SPECIAL_OFFER' | translate}}</button>
      <i class="pi pi-ellipsis-v spam-menu"></i>
    </div>
  </div>
</div>
<p-progressSpinner *ngIf="spinner" class="full_spinner"></p-progressSpinner>
<div class="mb-4" style="overflow-y: visible; max-width: 760px;">
  <div *ngFor="let project of projectList" class="div_product_plans">
    <div class="div_product_plans_header">
      <div class="d-flex align-items-center">
        <div class="logo_project me-3">
          <img src="{{getLogoUrl(project.value)}}" alt="Logo">
        </div>
        <span class="project_name">{{project.name}}</span>
      </div>
      <button class="btn_in_color w-25"
              (click)="addNewMembershipPlans(project.value)">{{'BUSINESS.ADD_NEW' | translate}}</button>
    </div>
    <p-progressSpinner *ngIf="spinnerMap[project.value]" class="full_spinner_medium"></p-progressSpinner>
    <ng-container *ngIf="membershipPlanListMap[project.value] && membershipPlanListMap[project.value].length > 0">
      <div class="plans_div_grid" style="height: 470px; overflow-y: auto; overflow-x: hidden;" infiniteScroll
           [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000"
           (scrolled)="loadMoreMembershipPlans(project.value)"
           [scrollWindow]="false">

        <div *ngFor="let plan of membershipPlanListMap[project.value]" class="vertical_component_card plan_card">
          <div class="component-list-card h-100 d-flex flex-column">
            <div class="text-center mem_plan_text mb-2 ">
              <label class="lbl_name lbl_ellipsis" title="{{plan.name}}">{{plan.name}}</label>
              <label class="lbl_price">${{plan.defaultMonthlyPrice}}</label>
              <label class="lbl_price">${{plan.defaultYearlyPrice}}</label>
              <div class="min-h-title">
                <label class="lbl_title w-100" title="{{plan.title}}">{{plan.title}}</label>
                <label class="lbl_desc lbl_ellipsis_vertical" title="{{plan.description}}">{{plan.description}}</label>
              </div>
              <label class="lbl_num">{{'BUSINESS.NUMBER_OF_VENUES'|translate}}</label>
              <label class="lbl_num_of_ven">{{plan.minNumberOfVenues}} - {{plan.maxNumberOfVenues}}</label>
              <div *ngFor="let country of plan.countryNames">
                <label class="lbl_title  w-100">{{country}}</label>
              </div>
            </div>
            <div class="mt-auto d-flex justify-content-between">
              <button class="btn_in_color" (click)="editMembershipPlan(plan.id, project.value)">{{ 'EDIT' |
                translate}}</button>
              <button class="btn_without_color btn_border_color " (click)="deleteMembershipPlan(plan.id, project.value)">{{ 'DELETE'
                | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

